import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { isEqual } from 'lodash';
import BaseInputLayout, { COMMON_INPUT_LAYOUT_DEFAULT_PROPS, getBaseInputLayoutProps } from './BaseInputLayout';
import { Checkbox, CheckboxGroupLayoutProps, CheckboxGroupLayoutType, CheckboxGroupValue } from 'framework/form';
import FormGroup from '@mui/material/FormGroup';

const CheckboxGroupLayout: CheckboxGroupLayoutType = ({
  options,
  value,
  onChangeCallback,
  onFocusCallback,
  onBlurCallback,
  source,
  isColumnDirection = false,
  checkedValues: initialCheckedValues = [],
  className,
  ...otherProps
}: CheckboxGroupLayoutProps) => {
  const props = {
    ...COMMON_INPUT_LAYOUT_DEFAULT_PROPS,
    ...otherProps,
  };
  const formValues = Array.isArray(value) ? value : initialCheckedValues;
  const [checkedValues, setCheckedValues] = useState<CheckboxGroupValue[]>(formValues);
  const shouldValidateAfterChangeRef = useRef(false);

  useEffect(() => {
    setCheckedValues(currentValues => (isEqual(currentValues, formValues) ? currentValues : formValues));
  }, [formValues]);

  useEffect(() => {
    if (shouldValidateAfterChangeRef.current) {
      shouldValidateAfterChangeRef.current = false;
      onBlurCallback?.();
    }
  }, [checkedValues, onBlurCallback]);

  const onChange = (itemValue: CheckboxGroupValue) => {
    if (onFocusCallback) {
      onFocusCallback();
    }

    if (onChangeCallback) {
      let newActiveValue = [];

      if (checkedValues.includes(itemValue)) {
        newActiveValue = checkedValues.filter(currentValue => currentValue !== itemValue);
      } else {
        newActiveValue = [...checkedValues, itemValue];
      }

      shouldValidateAfterChangeRef.current = true;
      setCheckedValues(newActiveValue);

      onChangeCallback({
        [source]: newActiveValue,
      });
    }
  };

  return (
    <BaseInputLayout
      {...getBaseInputLayoutProps({ ...props, source })}
      className={classNames(className, { 'checkbox-form-group__column': isColumnDirection })}
    >
      <FormGroup row={!isColumnDirection}>
        {options.map(item => (
          <Checkbox
            key={item.value}
            value={checkedValues.includes(item.value)}
            label={item.label}
            disabled={Boolean(props.disabled)}
            source={String(item.value)}
            onChangeCallback={() => onChange(item.value)}
            fullWidth={false}
          />
        ))}
      </FormGroup>
    </BaseInputLayout>
  );
};

export default CheckboxGroupLayout;
